module.exports = __webpack_public_path__ + "img/logos.d80d3485.svg";